"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.millisToMinutesAndSeconds = void 0;
// eslint-disable-next-line import/prefer-default-export
var millisToMinutesAndSeconds = exports.millisToMinutesAndSeconds = function millisToMinutesAndSeconds(millis) {
  var minutes = Math.floor(millis / 60000);
  var seconds = (millis % 60000 / 1000).toFixed(0);
  return "".concat(minutes, ":").concat(+seconds < 10 ? '0' : '').concat(seconds);
};
//# sourceMappingURL=utils.js.map
